import { ListItem, MultiButton, MultiButtonProps, SlideoutDecoratorProps, Table } from "@mcleod/components";
import { Action, ProcessType } from "./ProcessingTypes";
import { ProcessingSlideout } from "./ProcessingSlideout";

export class ProcessingHandler {
    public multiButton: MultiButton;
    private table: Table;
    private processType: ProcessType;
    public buttonPostOnClick: (action: Action) => void;

    constructor(processType: ProcessType, table: Table, multiButtonProps?: Partial<MultiButtonProps>) {
        this.processType = processType;
        this.table = table;
        this.setupMultiButton(multiButtonProps);
    }

    private setupMultiButton(multiButtonProps: Partial<MultiButtonProps>) {
        this.multiButton = new MultiButton({
            dropdownItems: this.createDropdownLabels(),
            color: "primary.reverse",
            backgroundColor: "primary",
            width: 80,
            enabled: false,
            showSeparator: true,
            ...multiButtonProps,
        });
        this.multiButton.primaryButton.setProps({
            themeKey: "editRowDecorator.primaryButton",
            id: "multiButtonPrintAndPost",
            caption: "Post",
            enabled: false,
            tooltip: `Post ${this.processType.title} without first viewing an edit list`,
            onClick: () => {
                this.buttonPostOnClick(Action.POST)
            },
        });
        this.multiButton.secondaryButton.dropdownOverlayProps = {
            width: 120,
        };
        this.multiButton.secondaryButton.setProps({
            borderLeftColor: "primary.reverse",
            tooltip: "View other posting options",
        })
        this.table.addRightTool(this.multiButton);
    }

    private createDropdownLabels(): ListItem[] {
        return [
            new ListItem({
                value: Action.PRINT_AND_POST.toString(),
                text: "Edit List & Post",
                tooltip: "View edit list",
                onClick: () => {
                    this.buttonPostOnClick(Action.PRINT_AND_POST)
                }
            })
        ];
    }

    showSlideout(slideoutProps?: Partial<SlideoutDecoratorProps>) {
        new ProcessingSlideout(this.processType, slideoutProps);
    }

}
